/* eslint-disable no-unused-vars */
import Swiper from 'swiper/swiper-bundle';

const logosCarousel = () => {
    const carousels = document.getElementsByClassName('logos__itemsWrapper');
    if (!carousels.length) return;

    for (let i = 0; i < carousels.length; i += 1) {
        const carousel = carousels[i];
        const slider = carousel.getElementsByClassName('logos__items--carousel')[0];
        slider.setAttribute('id', `logos__items--carousel-${i}`);
        // add unique class to each pagination
        const pagination = carousel.getElementsByClassName('swiper-pagination')[0];
        pagination.classList.add(`swiper-pagination-${i}`);
        // add unique class to each next button
        const nextButton = carousel.getElementsByClassName('swiper-button-next')[0];
        nextButton.classList.add(`swiper-button-next-${i}`);
        // add unique class to each prev button
        const prevButton = carousel.getElementsByClassName('swiper-button-prev')[0];
        prevButton.classList.add(`swiper-button-prev-${i}`);

        // eslint-disable-next-line no-unused-vars
        const swiper = new Swiper(`#logos__items--carousel-${i}`, {
            // Optional parameters
            slidesPerView: 2,
            slidesPerGroup: 2,
            loop: true,
            spaceBetween: 20,
            grabCursor: true,
            watchOverflow: true,
            loopFillGroupWithBlank: true,
            // centeredSlides: true,
            // If we need pagination
            pagination: {
                el: `.logos__itemsWrapper .swiper-pagination-${i}`,
                clickable: true
            },
            // Navigation arrows
            navigation: {
                nextEl: `.logos__itemsWrapper button.swiper-button-next-${i}`,
                prevEl: `.logos__itemsWrapper button.swiper-button-prev-${i}`,
            },
            breakpoints: {
                // when window width is >= 480px
                300: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    loop: true,
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    loop: true,
                },
                // when window width is >= 920px
                920: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    loop: true,
                },
                // when window width is >= 1200x
                1200: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                    loop: true,
                }
            }
        });
    }
};

const testimonialsCarousel = () => {
    const carousels = document.getElementsByClassName('testimonials__carouselWrapper');
    if (!carousels.length) return;


    for (let i = 0; i < carousels.length; i += 1) {
        const carousel = carousels[i];
        const slider = carousel.getElementsByClassName('testimonials__carousel')[0];
        slider.setAttribute('id', `testimonials__carousel-${i}`);
        // add unique class to each pagination
        const pagination = carousel.getElementsByClassName('swiper-pagination')[0];
        pagination.classList.add(`swiper-pagination-${i}`);
        // add unique class to each next button
        const nextButton = carousel.getElementsByClassName('swiper-button-next')[0];
        nextButton.classList.add(`swiper-button-next-${i}`);
        // add unique class to each prev button
        const prevButton = carousel.getElementsByClassName('swiper-button-prev')[0];
        prevButton.classList.add(`swiper-button-prev-${i}`);

        const testimonialsCarouselSwiper = new Swiper(`#testimonials__carousel-${i}`, {
            // Optional parameters
            slidesPerView: 3,
            slidesPerGroup: 1,
            loop: false,
            spaceBetween: 20,
            grabCursor: true,
            watchOverflow: true,
            // centeredSlides: true,
            // If we need pagination
            pagination: {
                el: `.testimonials__carouselWrapper .swiper-pagination-${i}`,
                clickable: true
            },
            // Navigation arrows
            navigation: {
                nextEl: `.testimonials__carouselWrapper button.swiper-button-next-${i}`,
                prevEl: `.testimonials__carouselWrapper button.swiper-button-prev-${i}`,
            },
            breakpoints: {
                // when window width is >= 480px
                300: {
                    slidesPerView: 1,
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: 2,
                },
                // when window width is >= 920px
                920: {
                    slidesPerView: 3,
                },
            }
            
        });
    }

};

const bannerVideoCarousel = () => {
    const carousels = document.getElementsByClassName('bannerVideo__carouselWrapper');
    if (!carousels.length) return;
    
    for (let i = 0; i < carousels.length; i += 1) {
        const carousel = carousels[i];
        const slider = carousel.getElementsByClassName('bannerVideo__carousel')[0];
        slider.setAttribute('id', `bannerVideo__carousel-${i}`);
        // add unique class to each pagination
        const pagination = carousel.getElementsByClassName('swiper-pagination')[0];
        pagination.classList.add(`swiper-pagination-${i}`);
        // add unique class to each next button
        const nextButton = carousel.getElementsByClassName('swiper-button-next')[0];
        nextButton.classList.add(`swiper-button-next-${i}`);
        // add unique class to each prev button
        const prevButton = carousel.getElementsByClassName('swiper-button-prev')[0];
        prevButton.classList.add(`swiper-button-prev-${i}`);

        const swiper = new Swiper(`#bannerVideo__carousel-${i}`, {
            // Optional parameters
            slidesPerView: 1,
            loop: true,
            spaceBetween: 0,
            grabCursor: true,
            watchOverflow: true,
            pagination: {
                el: `.bannerVideo__carouselWrapper .swiper-pagination-${i}`,
                clickable: true
            },
            // Navigation arrows
            navigation: {
                nextEl: `.bannerVideo__carouselWrapper button.swiper-button-next-${i}`,
                prevEl: `.bannerVideo__carouselWrapper button.swiper-button-prev-${i}`,
            },
        })

        const videos = document.querySelectorAll(".bannerVideo__carouselWrapper .swiper-slide video");

        videos.forEach((video) => {
            video.addEventListener("ended", function () {
                video.pause();
                video.currentTime = 0;
                swiper.slideNext();
            });
            
            let parentSlide = video.closest('.bannerVideoSlide');
            let progressBar = parentSlide.querySelector('.videoProgress');
            parentSlide.classList.add('video_slide');
            video.ontimeupdate = function(){
                const timeTotal = video.duration;
                let curTime = video.currentTime;
                let vidPcnt = (curTime/timeTotal)*100;
                progressBar.style.width = `${vidPcnt}%`;
               
            }
            video.addEventListener('click', function (event) {
                let playFade,
                    pauseFade; 
                if (this.paused) {
                    parentSlide.classList.remove('video_slide-paused','icon-fadeOut');
                    parentSlide.classList.add('video_slide-playing');
                    pagination.classList.remove('video_play-icon');
                    pagination.classList.add('video_pause-icon');
                    setTimeout(function(){parentSlide.classList.add('icon-fadeOut')}, 1000);
                    this.play(); 
                } else { 
                    parentSlide.classList.remove('video_slide-playing','icon-fadeOut');
                    parentSlide.classList.add('video_slide-paused');
                    pagination.classList.remove('video_pause-icon');
                    pagination.classList.add('video_play-icon');
                    setTimeout(function(){parentSlide.classList.add('icon-fadeOut')}, 2000);
                    this.pause();
                }
           });
        });

        swiper.on("slideChange", () => {
            document.querySelectorAll(".bannerVideo__carouselWrapper .swiper-slide video").forEach((video) => {
                if (!video.paused) {
                  video.pause();
                  video.currentTime = 0;
                }
            });

            const activeSlide = swiper.slides[swiper.activeIndex];
            const videos = activeSlide.querySelectorAll("video");
            pagination.classList.remove('video_play-icon');
            pagination.classList.add('video_pause-icon');
            
            videos.forEach((video) => {
                if (window.getComputedStyle(video).display !== "none") {
                    video.play();
                }
            });
        });
    }
}

const buyFormTestimonialsCarousel = () => {
    const carousels = document.getElementsByClassName('buyFormComponent__testimonials');
    if (!carousels.length) return;

    for (let i = 0; i < carousels.length; i += 1) {
        const carousel = carousels[i];
        const slider = carousel.getElementsByClassName('buyFormComponent__testimonials__carousel')[0];
        slider.setAttribute('id', `buyFormComponent__testimonials__carousel-${i}`);
        // add unique class to each pagination
        const pagination = carousel.getElementsByClassName('swiper-pagination')[0];
        pagination.classList.add(`swiper-pagination-${i}`);

        const swiper = new Swiper(`#buyFormComponent__testimonials__carousel-${i}`, {
            // Optional parameters
            slidesPerView: 1,
            loop: true,
            spaceBetween: 0,
            grabCursor: true,
            watchOverflow: true,
            pagination: {
                el: `.buyFormComponent__testimonials .swiper-pagination-${i}`,
                clickable: true
            },
        })
    }

}

/**
 * Function to run when this module is called from site.js
 */
const init = () => {

    logosCarousel();
    testimonialsCarousel();
    bannerVideoCarousel();
    buyFormTestimonialsCarousel();

};

export default init;
